export default "__VITE_ASSET__DSUZq9NI__"